module.exports = [{"id":1,"src":"./images/project1.png","text":"Ut at dolor ","link":"https://serginio06.github.io/angular-ivanchenko"},{"id":2,"src":"./images/project2.png","text":"Ut at dolor ","link":"https://serginio06.github.io/theHam"},{"id":3,"src":"./images/project3.png","text":"Ut at dolor","link":"https://github.com/Serginio06/display"},{"id":4,"src":"./images/project4.jpg","text":"Ut at dolor","link":"https://serginio06.github.io/aboutMe/"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/projects.json
// module id = 254
// module chunks = 0